import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Loading extends Component {

    constructor(props) {
        super(props);

    }


    render() {
        const { t } = this.props;
        return (
            <div className="loading">
                <div className="loading-image">
                    <img src={`/Public/images/loading-buffering.gif`} />
                    <div className="loading-title">
                        <h4>Loading...</h4>
                    </div>
                </div>
            </div>

        );
    }
}

export default withTranslation()(Loading);
